import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';


import Tour from 'reactour';

import BI from './newBI';
import FormInfo from './FormInfo';

class TourGuide extends Component {
  constructor() {
    super();
    this.state = {
      isTourOpen: false,
      isShowingMore: false,
    };
  }

  toggleShowMore = () => {
    this.setState(prevState => ({
      isShowingMore: !prevState.isShowingMore,
    }));
  };

  closeTour = () => {
    this.setState({ isTourOpen: false });
  };

  openTour = () => {
    this.setState({ isTourOpen: true });
  };

  render() {
    const { isTourOpen, isShowingMore } = this.state;
    const accentColor = '#537ccd';
    // window.gtag('event', 'conversion', { send_to: 'AW-767300505/68IHCM3vrM4BEJmn8O0C' });

    return (
      <div>
        <FormInfo tourOpen={this.openTour} />
        <BI
          openTour={this.openTour}
          toggleShowMore={this.toggleShowMore}
          isShowingMore={isShowingMore}
        />
        <Tour
          onRequestClose={this.closeTour}
          steps={tourConfig}
          isOpen={isTourOpen}
          maskClassName="mask"
          className="helper"
          rounded={5}
          accentColor={accentColor}
        />
      </div>
    );
  }
}
const tourConfig = [
  {
    selector: '[data-tut="reactour__"]',
    content: () => (
      <div >
        <Grid item xs={8} justify="space-between" >
          <Grid container spacing={3} justify="center" direction="column" alignItems="center">
            <Grid item>
              <Typography gutterBottom variant="headline" component="h1" >
                Olá! Seja bem-vindo(a)
              </Typography>
              <Typography gutterBottom component="p" color="textSecondary" >
                O Puntu é sua ferramenta para apresentar de
                forma prática e rápida a frequência dos seus colaboradores.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </div>
    ),
  },
  {
    selector: '[data-tut="reactour__pontualidade"]',
    content: 'Aqui você vê quem chegou no local de trabalho e sua pontualidade.',
  },
  {
    selector: '[data-tut="reactour__Mapa"]',
    content:
    'Acompanhe os colaboradores que registram ponto fora do local',
  },
  {
    selector: '[data-tut="reactour"]',
    content:
  <React.Fragment>
    Já sabe por onde começar?
    <Button
      href="https://support.puntu.digital/"
      color="primary"
      target="_blank"
    >
      Ver o passo a passo
    </Button>
    <Button
      component={Link}
      to="/funcionarios/importar"
      color="primary"
    >
      Importar Funcionários
    </Button>
  </React.Fragment>,
  },
];

export default TourGuide;
